module.exports = __webpack_public_path__ + "static/img/484.ba5313d.png";